
// via:
// https://stackoverflow.com/questions/2802341/javascript-natural-sort-of-alphanumerical-strings
var collator = new Intl.Collator(undefined, {
	numeric: true,
	sensitivity: 'base'
});

/**
 * Natural sort function for strings/numbers
 * @function
 */
export const naturalSort = collator.compare;



/**
 * Get numeric value if it is possible
 * @param  {any} val - Original value
 * @return {any}     - Converted number if possible, otherwise null
 */
export function getNumValIfPossible(val) {
  var returnObj = {
    val: val,
    isNaN: false
  };

  if (valueIsInvalid(val)) return returnObj;

  var numVal = (Number(val));
  if (Number.isNaN(numVal)) returnObj.isNaN = true;
  else returnObj.val = numVal;

  return returnObj;
}

/**
 * Checks a value to see if it qualifies as existing
 * @type {Boolean}
 */
export function valueIsInvalid(val) {
  return (val === undefined || val === null || val === "undefined" || val === "");
}


/**
 * Merges two objects, combining array values uniquely and overwriting other values.
 * @param {Object} obj1 - The first object to merge. {a: [1, 2], b: [3, 4]}
 * @param {Object} obj2 - The second object to merge. {a: [2, 3], c: [5, 6]}
 * @returns {Object} - The merged object with unique array values. {a: [1, 2, 3], b: [3, 4], c: [5, 6]}
 */
export function mergeArrays (obj1, obj2) {
  // Create a shallow copy of obj1 to avoid mutating the original object
  const result = { ...obj1 };

  // Iterate over each key in obj2
  for (const key in obj2) {
    // Check if the key exists directly on obj2 (not inherited)
    if (obj2.hasOwnProperty(key)) {
      // Check if the value associated with the key is an array
      if (Array.isArray(obj2[key])) {
        // If the key exists in result and its value is an array, merge unique values
        // Otherwise, assign the array from obj2 to the key in result
        result[key] = result[key] 
          ? [...new Set([...result[key], ...obj2[key]])] 
          : obj2[key];
      } else {
        // If the value is not an array, directly assign the value from obj2 to result
        result[key] = obj2[key];
      }
    }
  }

  // Return the merged result object
  return result;
};